import Text from 'components/Text/Text';
import React from 'react';
import DownloadFileBtn from './components/DownloadFileBtn';
import style from './WatchesTab.module.scss';

const WatchesTab: React.FC = () => {
	return (
		<div className={style.container} data-test="WatchesTab">
			<div className={style.fieldsWrapper}>
				<Text
					translationNameSpace="form"
					translationKey="infoHeading"
					theme="secondary"
					size="l"
					weight="bold"
				/>
				<DownloadFileBtn />
			</div>
		</div>
	);
};

export default WatchesTab;
